<div class="overflow-menu" (clickOutside)="overflowMenuIPActive.set(false)">
  <button
    class="overflow-menu__button button button--small button--secondary"
    [class.active]="overflowMenuIPActive()"
    (click)="toggleOverflowMenu()"
  >
    <svg-icon src="assets/images/icons/+.svg" class="button__icon"></svg-icon>
    <span> {{ "Global.NewAdd" | translate }}</span>
  </button>
  <div class="overflow-menu__items">
    <div class="overflow-menu__item" (click)="openRequestPrefixDialog($event)">
      {{ "OverflowMenu.RequestPrefix" | translate }}
    </div>
    <div class="overflow-menu__item" (click)="openAddPrefixDialog($event)">
      {{ "OverflowMenu.AddPrefix" | translate }}
    </div>
  </div>
</div>
